import { ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";

import theme from "./theme";
import { router } from "./navigation/router";
import useAuthenticate from "./auth/hooks/useAuthenticate";
import { RateLimitProvider } from "./context/RateLimitContext";
import { OfflineProvider } from "./context/OfflineContext";
import useGlobalErrorHandler from "./hooks/useGlobalErrorHandler";

// Inner component that uses hooks requiring Provider contexts
const AppContent = () => {
  useAuthenticate();
  useGlobalErrorHandler(); // Catch any unhandled network errors globally
  return <RouterProvider router={router} />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RateLimitProvider>
        <OfflineProvider>
          <AppContent />
        </OfflineProvider>
      </RateLimitProvider>
    </ThemeProvider>
  );
}

export default App;
